import React, { useState, lazy, Suspense, useEffect} from "react";
import "@fontsource/poppins";
import "./App.css";
import axios from "axios";
import Loader from "./components/Loader";
import MediaQuery from "react-responsive";
import jsonData from "./components/ai-branding.json";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import { CookieSetting } from "cookiesetting-component";

const Navbar = lazy(() => import("../src/components/PostEvent/Header/index.js"));
const Body = lazy(() => import(".././src/components/PostEvent/Body"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import('./components/Video/Video.js'));
const PostEventMemories = lazy(() => import('../src/components/PostEvent/PostEventMemories'))
const Thankyou = lazy(() => import(".././src/components/PostEvent/Thankyou.js"));
const SubscribeForEventNotifications = lazy(() =>  import("../src/components/PostEvent/SubscribeForEventNotifications.js"));
const VideoHighlights = lazy(() =>  import("../src/components/PostEvent/VideoHighlights.js"));
const MemoriesHighlights = lazy(() =>  import("../src/components/PostEvent/MemoriesHighlight.js"));
const PostSocial = lazy(() =>  import("../src/components/PostEvent/PostSocial"));
//const PostEventVideo = lazy(() =>  import("../src/components/PostEvent/PostEventVideos.js"));


function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const appVersion = appversion.version;
  // console.log(appVersion);

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
  
  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);


  return (

    <>
     <CacheBuster
        currentVersion={appversion.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        //If public assets are hosted somewhere other than root on your server.
        metaFileDirectory={process.env.PUBLIC_URL}
      >
         {links ? (
    <>  
    <div className="bodyContainer">
       {/* <img src={imgCDNURL + "topleftorangeshadow.png"} className="flower2 img-fluid" 
                            alt="Flower" />  
       <img src={imgCDNURL + "upperdotted.png"} className="dot1"/>                                        */}
       <Suspense fallback={<div />}> 
        <Navbar />
      </Suspense>       
      <Suspense fallback={<div />}> 
        <Body handleVideo={handleVideo} videoToggle={videoToggle}  links={links.current}/>
      </Suspense>
      {/* <Suspense fallback={<div />}> 
        <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
      </Suspense> */}
      <Suspense fallback={<div />}>
      <PostEventMemories />    
      </Suspense>     
      <Suspense fallback={<div />}>
      <PostSocial handleVideo={handleVideo} videoToggle={videoToggle} links={links.current} />    
      </Suspense>     
      <Suspense fallback={<div />}>
        <Thankyou links={links.current} />
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <Suspense fallback={<div />}>
        <VideoHighlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <MemoriesHighlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && <Video handleVideo={handleVideo} videoToggle={videoToggle}/>}
      </Suspense>
    </div>
    </>
            ) : (
              <div>Loading...</div>
            )}
                <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      </CacheBuster>
    </>
  );
}

export default App;
